import { useSelector } from 'react-redux'
import { getUserRights } from '@src/modules/accounts/selectors/organization.selectors'

export function getHasAuthHook(component: RightSetEnum) {
  const rights = useSelector(getUserRights)

  switch (component) {
    case RightSetEnum.ACCOUNT:
      return (
        rights?.includes(UserRightsEnum.CAM_ACCOUNTS_WRITE) ||
        rights?.includes(UserRightsEnum.CAM_GENERAL_WRITE)
      )
    case RightSetEnum.GENERAL:
      return rights?.includes(UserRightsEnum.CAM_GENERAL_WRITE)
    default:
      return false
  }
}

export enum RightSetEnum {
  ACCOUNT = 'ACCOUNT',
  ALERTS = 'ALERTS',
  GENERAL = 'GENERAL',
  GUARDRAIL = 'GUARDRAIL'
}

export enum UserRightsEnum {
  CAM_GENERAL_READ = 'cam:general:read',
  CAM_GENERAL_WRITE = 'cam:general:write',
  CAM_ACCOUNTS_READ = 'cam:account:read',
  CAM_ACCOUNTS_WRITE = 'cam:account:write',
  CAM_GUARDRAIL_READ = 'cam:guardrail:read',
  CAM_GUARDRAIL_WRITE = 'cam:guardrail:write',
  CAM_ALERTS_READ = 'cam:alerts:read',
  CAM_ALERTS_WRITE = 'cam:alerts:write'
}
